<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import ReviewEntity from "@apps/reviews/entities/ReviewEntity";

    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";
    import Slider from "@components/Slider/Slider.svelte";
    import SliderController from "@components/Slider/SliderController";

    import ProductReviewsMiniSliderArrows from "./ProductReviewsMiniSliderArrows.svelte";
    import ReviewsSliderItem from "./ProductReviewsMiniSliderItem.svelte";

    export let reviews: ReviewEntity[];
    export let reviewsStatus: STATUS;

    const sliderController = new SliderController();
    const hasNext$ = sliderController.selectHasNext();
    const hasPrev$ = sliderController.selectHasPrev();

    const handleNext = (): void => {
        sliderController.next();
    };
    const handlePrev = (): void => {
        sliderController.prev();
    };

    $: skeleton = [STATUS.VIRGIN, STATUS.INITIAL_LOADING].includes(
        reviewsStatus
    );

    $: hideSlider = reviewsStatus === STATUS.READY && !reviews.length;
</script>

{#if !hideSlider}
    <div class="gw-rv-product-mini-slider">
        {#if skeleton}
            <div class="gw-rv-product-mini-slider__skeleton">
                <BaseSkeleton width="52px" height="52px" />

                <div class="gw-rv-product-mini-slider__skeleton-item">
                    <div class="gw-rv-product-mini-slider__skeleton-item-row">
                        <BaseSkeleton width="120px" height="22px" />
                        <BaseSkeleton width="180px" height="22px" />
                    </div>

                    <BaseSkeleton width="100px" height="22px" />
                </div>
            </div>
        {:else if reviews.length > 0}
            {#key reviews}
                <Slider
                    {sliderController}
                    perPage={1}
                    duration={450}
                    autoHeight={false}
                >
                    <svelte:fragment slot="slides">
                        {#each reviews as review}
                            <ReviewsSliderItem {review} on:openReview />
                        {/each}
                    </svelte:fragment>
                    <ProductReviewsMiniSliderArrows
                        slot="arrows"
                        on:nextSlide={handleNext}
                        on:prevSlide={handlePrev}
                        hasNext={$hasNext$}
                        hasPrev={$hasPrev$}
                    />
                </Slider>
            {/key}
        {/if}
    </div>
{/if}

<style lang="postcss">
    .gw-rv-product-mini-slider {
        display: flex;
        align-items: center;
        border-radius: 10px;
        height: 4.5em;
        background: #f2f4f7;
        overflow: hidden;

        &__skeleton {
            display: flex;
            justify-content: center;
            gap: 0.5em;
            align-items: center;

            margin: 0 2.5em;
            padding: 0.75em 0.25em;
        }

        &__skeleton-item {
            display: flex;
            gap: 0.25em;
            flex-direction: column;

            &-row {
                display: flex;
                gap: 0.25em;
            }
        }
    }
</style>
